export const selectTab = (state) => state.swReducer.tab;
export const selectTable = (state) => state.swReducer.table;
export const selectDetails = (state) => state.swReducer.details;
export const selectPageNum = (state) => state.swReducer.pageNum;
export const selectPageCount = (state) => state.swReducer.pageCount;
